export const isNullOrUndefinedOrEmpty = (
  value: string | Date | undefined | null
): Boolean => {
  if (value === null) return true;
  if (value === undefined) return true;
  if (value! === '') return true;
  return false;
};
